import React, { useContext } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import "./Footer.css";

const Footer = () => {

  const { language } = useContext(LanguageContext);

  return (
    <div className="footer_container">
      <div className="footer__content__conteiner">
        <p>{language === "german" ? "Copyright 2022 - SEPPmail AG" : "Copyright 2022 - SEPPmail AG"}</p>

          {language === "german" ? 
            <span><a href="https://www.seppmail.ch/impressum/">Impressum</a><p>|</p><a href="https://www.seppmail.ch/datenschutz/">Datenschutz</a></span> : 
            <span><a href="https://www.seppmail.ch/impressum/">Legal Notice</a> <p>|</p> <a href="https://www.seppmail.ch/en/privacy-policy/">Privacy Policy</a></span>}

      </div>
    </div>
  );
};

export default Footer;
